import { Trans } from '@lingui/macro';
import { useScreenSizeRatio } from 'hooks/useScreenSizeRatio';
import React from 'react';
import { useAppDispatch } from 'state/hooks';
import { updateScreenCursorState } from 'state/phonebooth/slice';

import * as S from './StatusScreen.styles';

type StatusRowProps = {
  title: string;
  isConnected: boolean;
  username?: string;
  onConnect: () => void;
  onDisconnect: () => void;
  hideDisconnect?: boolean;
};

const StatusRow: React.FC<StatusRowProps> = ({
  title,
  isConnected,
  username,
  hideDisconnect,
  onConnect,
  onDisconnect,
}) => {
  const dispatch = useAppDispatch();
  const sizeRatio = useScreenSizeRatio();

  return (
    <S.StatusRowWrapper sizeRatio={sizeRatio}>
      <S.StatusRowTextWrapper>
        <S.StatusRowTitle sizeRatio={sizeRatio}>
          {title}: {isConnected ? <Trans>Connected</Trans> : <Trans>Disconnected</Trans>}
        </S.StatusRowTitle>
        {username && <S.StatusRowUser sizeRatio={sizeRatio}>{username}</S.StatusRowUser>}
      </S.StatusRowTextWrapper>
      <S.AuthBtnWrapper>
        {isConnected && !hideDisconnect && (
          <S.AuthBtn
            sizeRatio={sizeRatio}
            type="button"
            onClick={() => onDisconnect()}
            onMouseEnter={() => dispatch(updateScreenCursorState('pointer'))}
            onMouseLeave={() => dispatch(updateScreenCursorState('hover'))}
          >
            <Trans>DISCONNECT</Trans>
          </S.AuthBtn>
        )}

        {!isConnected && (
          <S.AuthBtn
            sizeRatio={sizeRatio}
            type="button"
            onClick={() => onConnect()}
            onMouseEnter={() => dispatch(updateScreenCursorState('pointer'))}
            onMouseLeave={() => dispatch(updateScreenCursorState('hover'))}
          >
            <Trans>CONNECT</Trans>
          </S.AuthBtn>
        )}
      </S.AuthBtnWrapper>
    </S.StatusRowWrapper>
  );
};

export default StatusRow;
